// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'AkkuratLL', 'AkkuratLL Fallback'"},"className":"__className_8a1f1e","variable":"__variable_8a1f1e"};